import { render } from "./ProductShowcase.vue?vue&type=template&id=8a4bbd84&scoped=true"
import script from "./ProductShowcase.vue?vue&type=script&lang=js"
export * from "./ProductShowcase.vue?vue&type=script&lang=js"

import "./ProductShowcase.vue?vue&type=style&index=0&id=8a4bbd84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4bbd84"]])

export default __exports__